import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import {
  FaPencilAlt, FaTrash, FaLayerGroup, FaUser, FaFileAlt, FaWhatsapp, FaFileImage,
  FaVideo
} from 'react-icons/fa';

import PropertyAPI from '../../api/PropertyAPI';
import ApiUiController from '../../controller/ApiUiController';

import PropertyContactPopup from '../contact/PropertyContactPopup';
import InnerPropertyContactList from '../contact/InnerPropertyContactList';
import PropertyDetails from './PropertyDetails';
import PropertyInformation from './PropertyInformation';

import DocumentPopup from '../meeting/DocumentPopup';
import InnerDocumentList from '../document/InnerDocumentList';
import WhatsAppPopup from '../whatsapp/WhatsAppPopup';

import LeadConst from '../../util/LeadConst';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';

import PropertyPreviewDesign2 from './PropertyDesign2';

import "./PropertyPreview.css";
import { Dropdown } from 'react-bootstrap';

class PropertyPreview extends React.Component {

  static Refresh = 'refresh';
  static Call = 'call';
  static Meeting = 'meeting';
  static Document = 'document';
  static Image = 'image';
  static Video = 'video';
  static SMS = 'sms';
  static Email = 'email';
  static SalesOrder = 'sales-order';
  static Contact = 'contact';
  static WhatsApp = 'whats-app';

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.property;
    this.id = parseInt(props.match.params.propertyId);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/preview'));

    this.state = {
      inApiCall: this.id !== 0, popup: null,
      call: null, meeting: null, document: null, email: 0, sms: 0, whatsApp: 0,
      designView: reactLocalStorage.get("property_design") || '2'
    };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.ContactList = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.ContactAdd = Util.isAllow(this.models.contact.permission, Const.PermAdd);

    this.DocList = Util.isAllow(this.models.document.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);

    this.HideAllContact = Util.isAllow(this.models.property.permission, Const.HideAllContact);
    this.HideOthersContact = Util.isAllow(this.models.property.permission, Const.HideOtherContact);
    this.HideOtherContactView = false;
    this.docFormats = Const.FileType;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.id !== parseInt(props.match.params.propertyId)) {
      this.id = parseInt(props.match.params.propertyId);
      this.setState({ ...this.state, inApiCall: true });
      PropertyAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
    }
  }

  componentDidMount() {
    if (this.id) {
      PropertyAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
    }
  }

  onReceived = (res) => {
    this.property = res;
    if (this.HideOthersContact) {
      if (!this.property.responsible_person.includes('~' + this.user.user_id + '~')) { this.HideOtherContactView = true; }
    }
    this.setState({ ...this.state, inApiCall: false });
  };
  onFail = (res) => { console.log(res); };

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    PropertyAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  };

  onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.property)}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      PropertyAPI.delete(this.property.id, this.onDeleteSuccess,
        this.props.failure, this.props.logout);
    });

  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    this.props.navigate('/property');
  };

  updateMater = () => {
    this.setState({ ...this.state, inApiCall: true, popup: null });
    PropertyAPI.get(this.id, this.onReceived, this.props.failure, this.props.logout);
  };

  showDetails = (model, field) => {
    if (field === PropertyPreview.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if (field === PropertyPreview.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  };

  showPopUp = (model, field) => {
    let tmp = { ...this.state };
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp });
  };

  hidePopUp = () => this.setState({ ...this.state, popup: PropertyPreview.Refresh });

  onLeads = () => {
    const property = this.property;
    let filter = [];

    const fields = this.models.lead.fields;
    const SearchLead = reactLocalStorage.getObject(LeadConst.SearchLead);
    for (let i = 0; i < SearchLead.length; i++) {
      const field = SearchLead[i];
      if (!fields[field]) {
        continue;
      }
      const type = fields[field].field_type;
      if ((type === Const.Number || type === Const.Decimal)) {
        if (field === LeadConst.MinBudget && property.price) {
          // filter.push({ field, type, condition: 'start-with', value: `${property.price}~` });
        } else if (property[field]) {
          // filter.push({ field, type, condition: 'start-with', value: `${property[field]}~` });
        }
      } else if (type.includes(Const.Select) && property[field]) {
        const value = typeof property[field] === 'string' && property[field].includes(Const.Opt)
          ? property[field] : `~${property[field]}~`;
        filter.push({ field, type, condition: 'in', value });
      }
    }
    this.props.navigate(`/lead?filters=${JSON.stringify(filter)}`);
  };

  redirectAddContact = id => this.props.navigate(`/contact/add-edit/${id}`);

  addContact = contact => {
    this.setState({ ...this.state, inApiCall: true, popup: null });
    PropertyAPI.addContact(this.id, contact, this.onReceived, () => this.setState({ ...this.state, inApiCall: false }));
  };

  setDesign = (designView) => {
    reactLocalStorage.set("property_design", designView);
    this.setState({ designView });
  };

  render() {
    let param = {};
    const PropertyContactPopUp = this.ContactAdd ?
      <PropertyContactPopup show={this.state.popup === PropertyPreview.Contact} onHide={this.hidePopUp}
        redirect={this.redirectAddContact} addContact={this.addContact} model_id={this.id}
        model_no={Const.Property} reload={this.updateMater} />
      : null;
    const ContactButton = (this.HideAllContact || this.HideOtherContactView) ? null : (this.ContactAdd ?
      <span className="buttons sales" variant="primary"
        onClick={() => this.showPopUp(null, PropertyPreview.Contact)}><FaUser /> Owner Details
      </span> : null);
    const ContactList = (this.HideAllContact || this.HideOtherContactView) ? null : (this.ContactList ?
      <InnerPropertyContactList id={this.id} type={Const.Property} {...param}
        onLoad={this.onLoadContacts} reload={this.updateMater} show={this.showDetails}
        edit={this.redirectAddContact} title="Owner Details" /> : null);

    const ImagePopUp = this.DocAdd ?
      <DocumentPopup show={this.state.popup === PropertyPreview.Image} onHide={this.hidePopUp}
        document={this.state.document} reload={this.updateMater} model_no={Const.Property}
        model_id={this.id} title="Add Image" document_type={this.docFormats[0]} /> : null;
    const VideoPopUp = this.DocAdd ?
      <DocumentPopup show={this.state.popup === PropertyPreview.Video} onHide={this.hidePopUp}
        document={this.state.document} reload={this.updateMater} model_no={Const.Property}
        model_id={this.id} title="Add Video" document_type={this.docFormats[1]} /> : null;
    const DocumentPopUp = this.DocAdd ?
      <DocumentPopup show={this.state.popup === PropertyPreview.Document} onHide={this.hidePopUp}
        document={this.state.document} reload={this.updateMater} model_no={Const.Property}
        model_id={this.id} title="Add Document" document_type={this.docFormats[2]} /> : null;

    const DocumentButton = this.DocAdd ?
      <span className="buttons update" variant="primary"
        onClick={() => this.showPopUp(null, PropertyPreview.Document)}><FaFileAlt /> Document Upload
      </span> : null;
    const ImageButton = this.DocAdd ?
      <span className="buttons sales" variant="primary"
        onClick={() => this.showPopUp(null, PropertyPreview.Image)}><FaFileImage /> Image Upload
      </span> : null;
    const VideoButton = this.DocAdd ?
      <span className="buttons whtsapp" variant="primary"
        onClick={() => this.showPopUp(null, PropertyPreview.Video)}><FaVideo /> Video Upload
      </span> : null;
    const DocList = this.DocList ?
      <InnerDocumentList id={this.id} type={Const.Property} {...param}
        reload={this.updateMater} title="Images" sefUrl={this.property?.sef_url} qrUrl={this.property?.qr_url} /> : null;

    return (
      <section className="previewpage">
        {PropertyContactPopUp} {DocumentPopUp} {ImagePopUp} {VideoPopUp}

        <WhatsAppPopup show={this.state.popup === PropertyPreview.WhatsApp} onHide={this.hidePopUp}
          data={this.property} model={this.model} />
        <ApiUiController inApiCall={this.state.inApiCall}>

          {this.state.designView === '1' ? (
            <div className="container-fluid" >
              <>
                <div className="row lead-mt">
                  <div className="col-md-3">
                    <div className="title_page">
                      <h2>Property - {this.property && this.property.name}</h2>
                    </div>
                  </div>

                 <div className="col-md-9 lead-btns-col">
                    <span
                      className="action-btns-lg"
                      style={{
                        display: "inline-flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "3px",
                      }}
                    >
                        {this.Update && (
                          <span className="buttons update">
                            <NavLink to={`${this.base}/add-edit/${this.id}`}>
                              <FaPencilAlt /> Update
                            </NavLink>
                          </span>
                        )}

                        {this.Delete && (
                          <span className="buttons delete" onClick={this.onDelete}>
                            <FaTrash /> Delete
                          </span>
                        )}

                        <span className="buttons primary" onClick={this.onLeads}>
                          <FaLayerGroup /> Leads
                        </span>

                        {ImageButton}
                        {VideoButton}
                        {DocumentButton}
                        {ContactButton}

                        <span
                          className="buttons whtsapp"
                          onClick={() => this.showPopUp({}, PropertyPreview.WhatsApp)}
                        >
                          <FaWhatsapp /> WhatsApp
                        </span>

                        <Dropdown className="d-inline-block ms-2">
                          <Dropdown.Toggle variant="outline-dark" size="sm" id="design-dropdown">
                            Design {this.state.designView}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => this.setDesign('1')}>Design 1</Dropdown.Item>
                            <Dropdown.Item onClick={() => this.setDesign('2')}>Design 2</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>

                    </span>
                  </div>

                </div>
                {DocList}
                <div className="row tablesrow">
                  <div className="col-md-8">
                    <PropertyDetails
                      model={this.model}
                      property={this.property}
                      PropertyName={this.property && this.property.name}
                    />
                  </div>

                  <div className="col-md-12">
                    <PropertyInformation model={this.model} property={this.property} />
                    {ContactList}
                  </div>
                </div>
              </>
            </div>
          ) : (
            <PropertyPreviewDesign2 setDesign={this.setDesign} designView={this.state.designView} {...this.props} />
          )}
        </ApiUiController>
      </section >
    );
  }
}
export default withRouter(PropertyPreview);